import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandCheckboxCheckedIcon, DownloadIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    downloadButtonClick: () => void;
    propertyPlan: string;
}

export const GalleryHolderPropertyPlanAuthConfirmationModal = (props: IProps) => {
    return (
        <div className={card}>
            <BrandCheckboxCheckedIcon size="8" wrapperSize="8" wrapperColor="var(--colors-primary)" />
            <Text align="center" variant="headline_4">
                Rzut jest gotowy do pobrania
            </Text>
            <div className={buttonStyle}>
                <Button
                    onClick={props.downloadButtonClick}
                    variant="filled_primary"
                    href={props.propertyPlan}
                    target="_blank"
                    iconLeft={DownloadIcon}
                    fullWidth
                >
                    Pobierz
                </Button>
            </div>
        </div>
    );
};

const card = css({
    width: "100%",
    backgroundColor: "#fff",
    gap: 3,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    md: {
        borderRadius: 3,
        pb: 1,
        pl: 1,
        pr: 1
    }
});

const buttonStyle = css({
    display: "flex",
    justifyContent: "center",
    width: "100%"
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandCheckboxCheckedIcon, DownloadIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    downloadButtonClick: () => void;
    propertyPlan: string;
}

export const GalleryHolderPropertyPlanAuthConfirmationModal = (props: IProps) => {
    return (
        <div className={card}>
            <BrandCheckboxCheckedIcon size="8" wrapperSize="8" wrapperColor="var(--colors-primary)" />
            <Text align="center" variant="headline_4">
                Rzut jest gotowy do pobrania
            </Text>
            <div className={buttonStyle}>
                <Button
                    onClick={props.downloadButtonClick}
                    variant="filled_primary"
                    href={props.propertyPlan}
                    target="_blank"
                    iconLeft={DownloadIcon}
                    fullWidth
                >
                    Pobierz
                </Button>
            </div>
        </div>
    );
};

const card = css({
    width: "100%",
    backgroundColor: "#fff",
    gap: 3,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    md: {
        borderRadius: 3,
        pb: 1,
        pl: 1,
        pr: 1
    }
});

const buttonStyle = css({
    display: "flex",
    justifyContent: "center",
    width: "100%"
});
